(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("tiny-cookie"), require("qs"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define("smart-core-util", ["tiny-cookie", "qs", "axios"], factory);
	else if(typeof exports === 'object')
		exports["smart-core-util"] = factory(require("tiny-cookie"), require("qs"), require("axios"));
	else
		root["smart-core-util"] = factory(root["tiny-cookie"], root["qs"], root["axios"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_10__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var iThread = function () {
    function iThread() {
        _classCallCheck(this, iThread);
    }

    /**
     * 
     * @param {*} ms - 毫秒
     */


    _createClass(iThread, null, [{
        key: "sleep",
        value: function sleep(ms) {
            return new Promise(function (resolve) {
                return setTimeout(resolve, ms);
            });
        }
    }]);

    return iThread;
}();

exports.default = iThread;
module.exports = exports["default"];

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // import _uris from './uris.json';
// const _uris = require('./uris.json');


var _tinyCookie = __webpack_require__(2);

var _index = __webpack_require__(0);

var _index2 = _interopRequireDefault(_index);

var _qs = __webpack_require__(3);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * inject window.idomain
 */
(function () {
    var domain = document.domain;
    var re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/; //正则表达式 
    var isIP = re.test(domain);
    var isLocalhost = domain == "localhost";
    console.log('document domain:', domain);
    domain = isIP || isLocalhost ? domain : domain.substring(domain.indexOf('.') + 1);
    window.idomain = domain;
})();

var iStorage = function () {
    function iStorage() {
        _classCallCheck(this, iStorage);
    }

    /**
     * all url parameter populated to session storage
     * all cookie data populate to session storage
     * if debug mode, load mockdata.json
     * self check
     */


    _createClass(iStorage, null, [{
        key: 'install',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
                var queryString, populate;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                populate = function populate(data) {
                                    if (!data) return;
                                    Object.keys(data).forEach(function (key) {
                                        sessionStorage.removeItem(key);
                                        sessionStorage.setItem(key, data[key]);
                                    });
                                };

                                // options['round'] = options.round || 1;
                                populate((0, _tinyCookie.getAllCookies)());
                                queryString = location.search;

                                console.log('query string', queryString);
                                if (queryString) {
                                    queryString = queryString.substring(1);
                                    populate(_qs2.default.parse(queryString));
                                }

                                // if (!this.getUrlGateway() && options.round < 3) {
                                //     console.log("NO gateway,recursive install 3 times");
                                //     await iThread.sleep(200);
                                //     ++options.round;
                                //     await this.install(options);
                                // }
                                console.log("install ready:");
                                return _context.abrupt('return', Promise.resolve(true));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function install(_x) {
                return _ref.apply(this, arguments);
            }

            return install;
        }()
        /**
         * 
         * @param {*} key 
         */

    }, {
        key: 'getUriSetting',
        value: function getUriSetting(key) {
            try {
                var data = this.get("Uris"); // sessionStorage.getItem("Uris");
                if (this.isString(data)) {
                    data = JSON.parse(data);
                }
                return data["Uris"][key];
            } catch (e) {
                console.log("getUriSetting Error:" + e.message);
                return undefined; // "https://"
            }
        }
    }, {
        key: 'getAccessToken',
        value: function getAccessToken() {
            var data = this.get('token');
            // if (!data) {
            //     data = getCookie('token');
            // }
            return data;
        }
    }, {
        key: 'getUrlGateway',
        value: function getUrlGateway() {
            return this.getUriSetting("gateway");
        }
    }, {
        key: 'getAll',
        value: function getAll() {
            var sessionData = {};
            Object.keys(sessionStorage).forEach(function (key) {
                sessionData[key] = sessionStorage[key];
            });
            return sessionData;
        }
    }, {
        key: 'setAll',
        value: function setAll(data) {
            var _this = this;

            Object.keys(data).forEach(function (key) {
                _this.set(key, data[key]);
            });
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            if (value === undefined || value === null) {
                return;
            }
            sessionStorage.removeItem(key);
            var val = value;
            if (["string", "number", "boolean"].indexOf(typeof value === 'undefined' ? 'undefined' : _typeof(value)) < 0) {
                val = JSON.stringify(value);
            }
            sessionStorage.setItem(key, val);
        }
        /**
         * 
         * @param {*} key 
         * read from session first , if undefined , read from cookie
         */

    }, {
        key: 'get',
        value: function get(key) {
            var val = sessionStorage.getItem(key) || (0, _tinyCookie.getCookie)(key);
            if (val === null) {
                return null;
            }
            if (val == "true" || val == "false") {
                return val == "true";
            }
            if (/(^{.*}$)|(^\[.*\]$)/.test(val)) {
                return JSON.parse(val);
            }
            return val;
        }
    }, {
        key: 'remove',
        value: function remove(key) {
            sessionStorage.removeItem(key);
        }
    }, {
        key: 'clear',
        value: function clear() {
            sessionStorage.clear();
        }
    }, {
        key: 'removeAllCookies',
        value: function removeAllCookies(keys) {
            var _this2 = this;

            var keys = keys || Object.keys((0, _tinyCookie.getAllCookies)());
            keys.forEach(function (key) {
                (0, _tinyCookie.removeCookie)(key);
                (0, _tinyCookie.removeCookie)(key, { domain: window.idomain });
                _this2.remove(key);
            });
        }

        /**
         * 
         * @param {*} obj 
         *  判断对象是否是字符串
         */

    }, {
        key: 'isString',
        value: function isString(obj) {
            return Object.prototype.toString.call(obj) === "[object String]";
        }
    }]);

    return iStorage;
}();

exports.default = iStorage;
module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.iSecurity = exports.iValidator = exports.iRem = exports.iHtml = exports.iHttp = exports.iStorage = exports.iThread = exports.iObject = exports.iForm = undefined;

var _index = __webpack_require__(6);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(7);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(0);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(1);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(8);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(9);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(11);

var _index14 = _interopRequireDefault(_index13);

var _validator = __webpack_require__(12);

var _validator2 = _interopRequireDefault(_validator);

var _index15 = __webpack_require__(13);

var _index16 = _interopRequireDefault(_index15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.iForm = _index2.default;
exports.iObject = _index4.default;
exports.iThread = _index6.default;
exports.iStorage = _index8.default;
exports.iHttp = _index12.default;
exports.iHtml = _index10.default;
exports.iRem = _index14.default;
exports.iValidator = _validator2.default;
exports.iSecurity = _index16.default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var iForm = function iForm() {
    _classCallCheck(this, iForm);
};

exports.default = iForm;
module.exports = exports["default"];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var iObject = function iObject() {
    _classCallCheck(this, iObject);
};

exports.default = iObject;
module.exports = exports["default"];

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var iHtml = function () {
    function iHtml() {
        _classCallCheck(this, iHtml);
    }

    _createClass(iHtml, null, [{
        key: 'telCall',
        value: function telCall(telephone) {
            window.location.href = 'tel://' + telephone;
        }
    }]);

    return iHtml;
}();

exports.default = iHtml;
module.exports = exports['default'];

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(3);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// const CancelToken = axios.CancelToken;

var iHttp = function () {
    function iHttp(options) {
        _classCallCheck(this, iHttp);

        this.api = _axios2.default.create({
            baseURL: (options && options.baseURL ? options.baseURL : undefined) || _index2.default.getUrlGateway()
        });
        this.options = options;
        this.autoExtractData = options.autoExtractData || true;
        this.autoExtractResponseError = options.autoExtractResponseError || true;
        this.alert = options.alert || window.alert;
        this.block = options.block || function () {};
        this.unblock = options.unblock || function () {};
        // this.handle401 = options.handle401 || function () { };
        this.injectRequest();
        this.injectResponse();
        this.monitorStorage = [];
    }

    _createClass(iHttp, [{
        key: 'injectRequest',
        value: function injectRequest() {
            var _this = this;

            this.api.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
            // this.api.interceptors.request.use(null, (error) => {
            //     this.alert(error.message);
            // });
            this.api.interceptors.request.use(function (config) {
                // console.log('request interceptor');
                if (!config.noblock) {
                    _this.block();
                }
                config.cancelToken = new _axios2.default.CancelToken(function (c) {
                    _this.preventDuplicateRequest(config, c);
                });
                if (config.data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
                    config.data = _qs2.default.stringify(config.data);
                }
                _this.appendHeader(config);
                return config;
            });
        }
    }, {
        key: 'injectResponse',
        value: function injectResponse() {
            var _this2 = this;

            this.api.interceptors.response.use(undefined, function (error) {
                // console.log('error', JSON.stringify(error));
                var config = error.config;
                _this2.monitor(config, -1);
                if (!config.noblock) {
                    _this2.unblock();
                }
                // var data = error;
                var message = error.message;
                if (error.response && error.response.data) {
                    message = error.response.data.error_description || message;
                }
                _this2.alert(message);
            });
            this.api.interceptors.response.use(function (response) {
                // console.log('response',response);
                if (!response) {
                    return;
                }
                var config = response.config;
                _this2.monitor(response.config, -1);
                if (!config.noblock) {
                    _this2.unblock();
                }
                var filterResponse = response;
                if (_this2.autoExtractData) {
                    filterResponse = response && response.data ? response.data : null;
                }
                if (_this2.autoExtractResponseError) {
                    var responseData = filterResponse;
                    if (responseData && responseData.success != undefined && responseData.success == false) {
                        _this2.alert(responseData.msg || responseData.error || '未知错误');
                    }
                }
                return filterResponse;
            });
        }
    }, {
        key: 'appendHeader',
        value: function appendHeader(config) {
            var token = _index2.default.getAccessToken();
            if (token && token != null) {
                config.headers["Authorization"] = 'Bearer ' + token;
            }
            var organization_type = _index2.default.get("organization_type");
            if (organization_type == "Tenant") {
                config.headers["tenant_code"] = _index2.default.get("tenant_code");
            }
        }
        /**
         * same url, same data, must wait response 
         * @param {*} request 
         * @param {*} cancel 
         */

    }, {
        key: 'preventDuplicateRequest',
        value: function preventDuplicateRequest(config, c) {
            // console.log('config', config);
            var duplicated = this.monitorStorage.findIndex(function (item) {
                return item.url == config.url && item.data == config.data;
            });
            // var duplicated = this.monitorStorage.findIndex(item => item.url == config.url);
            // console.log('duplicated', duplicated);
            if (duplicated > -1) {
                console.log('config', config);
                console.log('duplicated', duplicated);
                c('当前请求进行中,请稍等');
                return;
            }
            this.monitor(config, 1);
        }
    }, {
        key: 'monitor',
        value: function monitor(config, action) {
            // console.log('monitor', config, action);
            if (!config) return;
            // console.log('config data tostring', config.data.toString());
            var url = config.url;
            var data = config.data;
            switch (action) {
                case 1:
                    this.monitorStorage.push({ url: url, data: data });
                    break;
                case -1:
                    this.monitorStorage.splice(this.monitorStorage.findIndex(function (item) {
                        return item.url == url && item.data == data;
                    }), 1);
                    break;
            }
            // console.log('this.monitorStorage',JSON.stringify(this.monitorStorage));
        }
    }]);

    return iHttp;
}();

exports.default = iHttp;
module.exports = exports['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var iRem = function () {
    function iRem() {
        _classCallCheck(this, iRem);
    }

    _createClass(iRem, null, [{
        key: 'install',
        value: function install(doc, win) {
            var docEl = doc.documentElement,
                resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                isPad = navigator.userAgent.match(/iPad/i) != null ? true : false;
            // function recalc() {
            //     console.log(isPad, 'isPad')
            //     var clientWidth = docEl.clientWidth;
            //     if (!clientWidth) return;
            //     isPad ? docEl.style.fontSize = 100 * (clientWidth / 768) + 'px' : docEl.style.fontSize = 100 * (clientWidth / 375) + 'px';
            // };
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            isPad ? docEl.style.fontSize = 100 * (clientWidth / 768) + 'px' : docEl.style.fontSize = 100 * (clientWidth / 375) + 'px';
            // if (!doc.addEventListener) return;
            // win.addEventListener(resizeEvt, recalc, false);
            // doc.addEventListener('DOMContentLoaded', recalc, false);
        }
    }]);

    return iRem;
}();

exports.default = iRem;
module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * model validator
 * 
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var iValidator = function () {
    function iValidator() {
        _classCallCheck(this, iValidator);
    }

    _createClass(iValidator, [{
        key: 'simpleValidate',


        /**
         * all key can not be empty
         * @param {*} param0 
         */
        value: function simpleValidate(_ref) {
            var model = _ref.model,
                toast = _ref.toast;

            var validator = {};
            Object.keys(model).forEach(function (key) {
                validator[key] = {
                    required: true,
                    description: '必填项不能为空'
                };
            });
            return this.validate({ model: model, validator: validator, toast: toast });
        }
        /**
         * 
         * @param {*} param0 
         */

    }, {
        key: 'validate',
        value: function validate(_ref2) {
            var model = _ref2.model,
                validator = _ref2.validator,
                toast = _ref2.toast;

            toast = toast || window.alert;
            // Object.keys(validator).forEach(function(key){})
            for (var key in validator) {

                var rule = validator[key];
                var description = typeof rule.description == "function" ? rule.description(model) : rule.description;
                var preCondition = rule.preCondition;

                var val = this.getItsVal(model, rule.getVal || key);

                // required
                if ((preCondition == undefined || preCondition && preCondition(model)) && rule.required && this.isEmpty(val)) {
                    toast(description);
                    return false;
                }
                // regExp
                if ((preCondition == undefined || preCondition && preCondition(model)) && rule.regExp && this.isValid(val, rule.regExp)) {
                    toast(rule.regExpMsg);
                    return false;
                }
                //expression = function , true false
                if ((preCondition == undefined || preCondition && preCondition(model)) && rule.expression && rule.expression(model)) {
                    toast(rule.expressionMsg);
                    return false;
                }
                //gt
                //lt
                //min
                //max
            }
            return true;
        }

        /**
         * 
         * @param {*} object 
         * @param {*} key, string or function 
         */

    }, {
        key: 'getItsVal',
        value: function getItsVal(object, key) {
            if (!key) return null;
            var val = null;
            if (typeof key === "function") {
                var fn = key;
                return fn(object);
            }
            return this.getPropertyValue(object, key);
        }

        /**
         * 
         * @param {*} object 
         * @param {*} 'model.key1.key2' 
         */

    }, {
        key: 'getPropertyValue',
        value: function getPropertyValue(object, key) {
            var keys = key.split('.');
            if (keys.length == 1) {
                return object[key];
            }
            var nextKeys = key.substring(key.indexOf('.') + 1);
            var nextObject = object[keys[0]];
            return this.getPropertyValue(nextObject, nextKeys);
        }

        /**
         * string -> trim() check
         * object ->
         */

    }, {
        key: 'isEmpty',
        value: function isEmpty(val) {
            if (val == null || val == undefined) return true;
            if (typeof val == "string") {
                val = val.trim();
                return val.length == 0;
            }
            if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) == "object") {
                return Object.keys(val).length == 0;
            }
            return !val;
        }
    }, {
        key: 'isValid',
        value: function isValid(val, regExp) {
            console.log(val);
            var pattern = new RegExp(regExp, 'im');
            console.log(pattern.test(val));
            return !pattern.test(val);
        }
    }]);

    return iValidator;
}();

exports.default = iValidator;
module.exports = exports['default'];

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tinyCookie = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var iSecurity = function () {
    function iSecurity() {
        _classCallCheck(this, iSecurity);
    }

    /**
     * every 10 seconds check token
     * 
     */


    _createClass(iSecurity, null, [{
        key: 'install401',
        value: function install401(_ref) {
            var messageBox = _ref.messageBox,
                handler = _ref.handler,
                message = _ref.message;

            message = message || "授权信息过期,请重新登录";
            setInterval(function () {
                var token = (0, _tinyCookie.getCookie)("token");
                console.log('monitor 401', token);
                if (!token) {
                    messageBox(message).then(function () {
                        handler();
                    });
                }
            }, 10000);
        }
    }]);

    return iSecurity;
}();

exports.default = iSecurity;
module.exports = exports['default'];

/***/ })
/******/ ]);
});
//# sourceMappingURL=smart-core-util.js.map


//////////////////
// WEBPACK FOOTER
// ../scripts/node_modules/smart-core-util/lib/smart-core-util.js
// module id = CLFZ
// module chunks = 1